module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"review_detail_title":"查看詳細評論"}}')
  delete Component.options._Ctor
}
